/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
//import "../sass/app.scss";
import Vue from "vue";
window.Vue = require('vue');

import router from './router';
import App from './App.vue';
import VueRouter from 'vue-router'
import Toasted from "vue-toasted";

// Setry
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

// Layouts
import DefaultLayout from './layouts/Default.vue';
import EmptyLayout from './layouts/Empty.vue';
import AdminLayout from "./layouts/Admin.vue";

import store from './store';
import helpers from "./helpers";

import { ethers } from "ethers";

window.covered_call = require("./contracts/call_abi.json")
window.put_selling = require("./contracts/put_abi.json")
window.ui_abi = require("./contracts/ui_abi.json")


/*
 *
 * BOOTSTRAP VUE
 *
 */
import {
    CollapsePlugin,
    NavPlugin,
    ButtonPlugin,
    NavbarPlugin,
    CardPlugin,
    LayoutPlugin,
    ProgressPlugin,
    DropdownPlugin,
    ModalPlugin,
    SidebarPlugin,
    FormTextareaPlugin,
    FormSelectPlugin,
    FormInputPlugin,
    FormCheckboxPlugin
} from "bootstrap-vue";


window.ethers = require('ethers');
Vue.use(ethers);
Vue.use(CollapsePlugin);
Vue.use(SidebarPlugin);
Vue.use(ButtonPlugin);
Vue.use(NavPlugin);
Vue.use(NavbarPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(ProgressPlugin);
Vue.use(DropdownPlugin);
Vue.use(ModalPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(Toasted, { position: "bottom-center", duration: 1500 });

// Layout Component
Vue.component("default-layout", DefaultLayout);
Vue.component("empty-layout", EmptyLayout);
Vue.component("admin-layout", AdminLayout);

import CountDown from "./components/CountDown";
Vue.component("count-down", CountDown);

// Optionally install the BootstrapVue icon components plugin
//import "bootstrap/dist/css/bootstrap.css";
//import "bootstrap-vue/dist/bootstrap-vue.css";


import { ServerTable, ClientTable } from 'vue-tables-2'
Vue.use(ClientTable, {});
Vue.use(ServerTable, {});

export const routers = new VueRouter({
    mode: 'history',
    router
});

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

Sentry.init({
  Vue,
  dsn: process.env.SENTRY_LARAVEL_DSN,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.mixin({
    methods: helpers
})



const app = new Vue({
    router,
    store,
    el: '#app',
    store,
    render: h => h(App)
});
